<template>
    <div class="task-list krs006 ict">
        <div class="dashboard_box_grp clear">
            <div class="tb-list_ty1">
                <div class="tb-header clear">
                    <div class="tb_num fl">
                        <div class="num" v-html="$i18nUtil.trans('search.000','총 {cnt}건', {cnt: totalElements})"></div>
                        <!-- 검색 조회시 노출 S -->
                        <div class="check_result" v-if="showSearchPaperTitle">
                            <div class="txt" v-html="$i18nUtil.trans('search.000.result','{search} 검색 결과 총 {cnt}건', {search: rtnSearchPaperTitle, cnt: totalElements})"></div>
                            <button type="button" @click="clearSearchPaperTitle">초기화</button>
                        </div>
                        <!-- //검색 조회시 노출 E -->
                    </div>

                    <div class="tb_sort fr">
                        <input type="checkbox" name="" id="chkReadFilterA" v-model="isReadFilter" @change="fireFilterRead"><label for="chkReadFilterA">{{ $i18nUtil.trans("button.paper.unread","미확인 보드 보기") }}</label>
                        <input type="checkbox" name="" id="chkBookmarkFilterA" v-model="isBookmarkFilter" @change="fireFilterBookmark"><label for="chkBookmarkFilterA">{{ $i18nUtil.trans("button.favorite","즐겨찾기 보기") }}</label>
                        <div class="dividing_line_ty1"></div>
                        <div class="search_ty2">
                            <button type="button" class="search-show" @click="isSearchArea = true" :class="isSearchArea ? 'active' : ''">검색</button>
                            <form action="" onsubmit="return false;" class="search-show">
                                <div class="input-box">
                                    <input type="text" 
                                        class="search-show"
                                        :class="searchPaperTitle == '' ? 'ico_search' : ''" 
                                        :placeholder="$i18nUtil.trans('message.placeholder.boardName','보드명 검색')" 
                                        @focus="$event.target.placeholder=''"
                                        @focusout="$event.target.placeholder=$i18nUtil.trans('message.placeholder.boardName','보드명 검색')"
                                        maxlength="21"
                                        v-model="searchPaperTitle" 
                                        @keyup.enter="getSearchBoardList()">
                                    <button type="reset" 
                                        class="input-txt-del" 
                                        @click="searchPaperTitle = ''" 
                                        v-if="searchPaperTitle != ''">입력 삭제</button>
                                    <button type="reset" class="btn_search" @click="getSearchBoardList()">검색</button>
                                </div>
                            </form>
                        </div>
                        <CommonFilterE :filterReset="filterReset" @updateCommonFilterE="updateCommonFilterE" :initFilter="initFilter" />
                    </div>
                </div><!-- //tb-header -->

                <v-data-table
                    v-model="selected"
                    :headers="headers"
                    :items="boardListFilter"  
                    :page.sync="page"
                    :must-sort="true"
                    :items-per-page="itemsPerPage"
                    :server-items-length="totalElements"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    @page-count="pageCount = $event"
                    hide-default-footer
                    class="tb-contents ins002a">

                <template v-slot:item="{ item }">
                    <tr :class="item.isState">
                    <td class="division">
                        <div type="button" :class="getEvaluateClassAndText(item).evaluateClass">
                            {{getEvaluateClassAndText(item).evaluateText}}
                        </div>
                        <div class="subject ell-multiline2" @click="goBoard(item)">{{ item.paperTitle }}</div>
                        <UserInfo 
                            :userId="item.regUserId" 
                            :userName="item.regUserName" 
                            :userNameEn="item.regUserNameEn"
                            :userCount="item.paperUserCount" 
                            :paperId="item.paperId" 
                            :isLinkedBoard="item.paperProjectLinkId != null"
                        />
                        <div class="dividing_line_ty3"  v-if="item.paperProjectLinkId != null"></div>
                        <div class="txt-linked ell-singleline" style="cursor: pointer;" @click="moveProject(item.linkProjectId)" v-if="item.paperProjectLinkId != null">Linked : {{item.linkProjectName}}</div>
                    </td>
                    <td class="txtc">
                        <button 
                            type="button" 
                            class="ico-switch_favorites small active" 
                            v-show="item.paperBookmarkId != null" 
                            @click="toggleBookmark(item)"
                        >
                            즐겨찾기
                        </button>
                        <button 
                            type="button" 
                            class="ico-switch_favorites small" 
                            v-show="item.paperBookmarkId == null"
                            @click="toggleBookmark(item)"
                        >
                            즐겨찾기
                        </button>
                    </td>
                    <td class="feedback txtc">
                        <span class="ico-txt_comment" v-if="item.commentCount < 1000">{{ item.commentCount }}</span>
                        <span class="ico-txt_comment" v-else-if="item.commentCount > 999">999+</span>
                    </td>
                    <td class="date txtc">
                        <!-- 24시간 이내-->
                        <momentAgo v-if="checkHours(item.lastUpdDate)" prefix="" suffix="전" :date="item.lastUpdDate" lang="kr"></momentAgo>
                        <!-- 24시간 이후-->
                        {{ !checkHours(item.lastUpdDate) ? replaceAll(item.lastUpdDate.substring(0, 10), "-", ".") :''}}
                        <!-- {{ !checkHours(item.lastUpdDate) ? item.lastUpdDate.substring(0,10).replaceAll("-", ".") : '' }} -->
                        <span class="ico-new" v-if="item.readCount == null || item.readCount == 0"></span>
                        <!-- {{ item.update }} <span :class="item.icoNew"></span> -->
                    </td>
                    <td class="author txtc">
                        <div class="droplayer tooltipmember relative right">
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on">
                                        <b>{{ defaultLanguage.indexOf('ko') != -1 ? item.lastUpdUserName : item.lastUpdUserNameEn != null ? item.lastUpdUserNameEn : item.lastUpdUserName }}</b>
                                    </v-btn>
                                </template>
                                <div class="dropdown-list">
                                    <UserTooltip
                                        :userId="item.lastUpdUserId"
                                    />
                                </div>
                            </v-menu>
                        </div>
                    </td>
                    <td class="txtc">
                        <div class="droplayer icon more right nosel">
                            <v-menu bottom left>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on"  @click="checkInOut($event, item, on, attrs)">더보기</v-btn>
                                </template>
                                <div class="dropdown-list">
                                    <div class="dropdown-list-item hidden"><div class="tit"><button type="button" @click="openPaperNewWindow(currentURL(),item);">{{ $i18nUtil.trans("button.paper.open.newWindow","새 창으로 보기") }}</button></div></div>
                                    <div class="dropdown-list-item hidden" v-if="item.paperProjectLinkId == null"><div class="tit"><button type="button" @click="infoShareReqPost(item);">{{ $i18nUtil.trans("title.ReqPostModal.shareInfo","정보공유 게시") }}</button></div></div>
                                    <div class="dropdown-list-item hidden" v-if="item.paperProjectLinkId == null"><div class="tit"><button type="button" @click="cooperationReqPost(item)">{{ $i18nUtil.trans("title.ReqPostModal.cooperation","회의/협의 게시") }}</button></div></div>
                                    <div class="dropdown-list-item hidden"><div class="tit"><button type="button" @click="copyURL(currentURL(),item)">{{ $i18nUtil.trans("button.paper.copy.url","보드 URL 복사") }}</button></div></div>
                                    <div class="dropdown-list-item hidden" v-if="item.paperProjectLinkId == null && tenantId != '203'"><div class="tit"><button type="button" @click="copyPaperModal(item)">{{ $i18nUtil.trans("button.paper.copy","보드 복제") }}</button></div></div>
                                    <div class="dropdown-list-item hidden" v-if="item.paperProjectLinkId == null"><div class="tit"><button type="button" @click="deleteBoard(item)">{{ $i18nUtil.trans("button.paper.delete","보드 삭제") }}</button></div></div>
                                </div>
                            </v-menu>
                        </div>
                    </td>
                    </tr>
                </template>
                <template slot="no-data">
                    <div class="nodata-txt-noicon" v-show="!isBookmarkFilter && !isReadFilter && !statusCheckYn && !gradeCheckYn && !showSearchPaperTitle">
                        <v-alert :value="true" v-html="$i18nUtil.trans('message.DashboardAllList.001','과제 보드를 등록하여 멤버들과<br> 협업해보세요.')">
                        </v-alert>
                        <button type="button" class="btn-primary-small black" @click="addBoard(null)">{{$i18nUtil.trans("button.paper.pro.add","과제 보드 추가")}}</button>
                    </div>
                    <div class="nodata-txt-noicon" v-show="isBookmarkFilter || isReadFilter || gradeCheckYn ||statusCheckYn || showSearchPaperTitle">
                        <v-alert :value="true">
                           {{ $i18nUtil.trans("search.007","조회된 결과가 없습니다.") }}
                        </v-alert>
                    </div>
                </template>
                </v-data-table>

                <div class="pagination" v-show="pageCount>0">
                    <v-pagination
                        v-model="page"
                        circle
                        :length="pageCount"
                        :total-visible="7"
                    ></v-pagination>
                </div>
            </div><!-- //tb-list_ty1 -->
        
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import CommonFilterE from "@/components/cowork/common/filter/CommonFilterE";
import reqPost from "../../../modal/ReqPostModal";
import CopyBoardModal from "@/components/cowork/general/board/modal/CopyBoardModal";
import axios from 'axios';
import Vue from 'vue';
import UserInfo from "@/components/cowork/common/user/UserInfo";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
import RegistBoardModal from "@/components/cowork/general/board/modal/RegistBoardModal";

export default {
    name: "simple",
    display: "Simple",
    order: 0,
    props:["loginUserIsInternalUser","publicYn"],
    components: {
       UserTooltip,
       CommonFilterE,
       UserInfo,
    },
    data() {
        return {
            tenantId : localStorage.getItem("tenantId"),
            dBHeight:null,
            toastInfo: {
                obj: this.$toasted,
                message: "",
                options: {
                    theme: "toasted-primary",
                    position: "bottom-left",
                    duration: 3000,
                },
            },

            headers: [
                { text: this.$i18nUtil.trans("entity.paper.filter.paperTitle","보드명"), value: 'paperTitle', sortable: true },
                { text: this.$i18nUtil.trans("entity.paper.filter.paperBookmar","즐겨찾기"), align: 'center', value: 'paperBookmarkId', sortable: false },
                { text: this.$i18nUtil.trans("entity.paper.filter.comment","의견/답변"), align: 'center', value: 'commentCount', sortable: false },
                { text: this.$i18nUtil.trans("entity.paper.filter.lastUpdate","마지막 업데이트"), align: 'center', value: 'lastUpdDate' },
                { text: this.$i18nUtil.trans("entity.paper.filter.lastUpdUserName","생성/수정자"), align: 'center', value: 'lastUpdUserName', sortable: false },
                { text: this.$i18nUtil.trans("entity.paper.filter.more","더보기"), align: 'center', value: 'more', sortable: false },
            ],
 
            page: 1,
            pageCount: 0,
            itemsPerPage: 10,
            selected: [],

            boardList: [],
            boardListFilter: [],

            showSearchBoardTitle: false,
            isSearchKeywordFlag: false,

            searchPaperTitle: '',
            rtnSearchPaperTitle: '',
            showSearchPaperTitle:false,
            isSearchArea: false,

            isBookmarkFilter: false,
            isReadFilter: false,

            /* 정렬 */
            totalElements: 0,
            sortBy: ['lastUpdDate'],
            sortDesc: [true],

            /* 페이지 변경 또는 정렬 이벤트시 */
            changeTableData: false,
            backDataSet:true,

            isSearch:false,
            gradeCodeList: [],
            statusList: [],

            filterReset: true,
            initFilter: [],
            gradeCheckYn : false,
            statusCheckYn : false,

            defaultLanguage : localStorage.getItem("defaultLanguage") || 'ko'
        };
    },
    mounted() {
        const self = this;
        $("html").click(function (e) {
            if (!$(e.target).hasClass("input-box") && !$(e.target).hasClass('search-show')) {
            self.isSearchArea = false;
        }
      });
    },
    computed: {
        ...mapState("project", ["projectInfo"]), // 현재 정보
        ...mapState("project", ["projectMemberList"]), // 현재 멤버정보
    },
    watch:{
        page:{
            handler() {
                if(this.changeTableData != true){
                    this.changeTableData = true;
                }
                window.scrollTo(0, 0);
            }
        },
        sortBy: {
            handler() { 
                if(this.changeTableData != true){ 
                    this.changeTableData = true;
                }
                window.scrollTo(0, 0);
            }
        },
        sortDesc: {
            handler() { 
                if(this.changeTableData != true){ 
                    this.changeTableData = true;
                }
                window.scrollTo(0, 0);
            }
        },
        changeTableData:{
            handler(){
                let obj = this;
                if(obj.changeTableData == true && obj.backDataSet == true){
                    setTimeout(() => {
                        obj.changeTableData = false;
                        // obj.boardListFilter = [];
                        // obj.boardList = [];
                        this.showLoadingbar();
                        obj.getBoardAllList(this.isSearch);
                    }, 500);
                }

                if(obj.backDataSet == false){
                    obj.changeTableData =false;
                }
            },
            deep: true
        },
    }, 
    methods: {
        ...mapActions("modals", ["showToast", "showModal"]), 
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION", "COWORK_REST_ACTION"]),
        setInitItem(state){

            this.filterReset = true;
            setTimeout(()=>{this.filterReset = false;}, 50);

            if(window.sessionStorage.getItem("moveBoard") === 'true'){
                // window.sessionStorage.setItem("moveBoard",false);
                // this.initFolder(targetFolderItem||null);
            }else{
                let stateArr = JSON.parse(window.sessionStorage.getItem("dashboard")) || [];
                if(stateArr.length == 0){
                    //저장
                    stateArr.push(state);
                    window.sessionStorage.setItem("dashboard",JSON.stringify(stateArr));
                }else{
                    let lastState = stateArr[stateArr.length-1];
                    if(lastState.currentTab == 0 && lastState.currentTab2 == 0 && lastState.currentTab3 == 0){
                        // 같은 탭 누른 경우 .
                    }else{
                        // 다른 탭에서 누른경우
                        stateArr.push(state);
                        window.sessionStorage.setItem("dashboard",JSON.stringify(stateArr));
                    }
                } 
                if(window.sessionStorage.getItem("prevBtn")  === 'true' ){ 
                    // 뒤로가기 버튼으로 접근.
                    // this.initFolder(state||null); 
                }else{
                    // this.initFolder(targetFolderItem||null); 
                }
            }

            this.getBoardAllList();
        },
        getBoardAllList(isSearch){
            let obj = this;
            let pageParam = obj.page;
            //뒤로가기로 접근시 데이터 set
            if(window.sessionStorage.getItem("prevBtn") === 'true' || window.sessionStorage.getItem("moveBoard") === 'true'){
                window.sessionStorage.setItem("moveBoard",false);
                window.sessionStorage.setItem("prevBtn",false);
                let stateArr = JSON.parse(window.sessionStorage.getItem("dashboard")) || [];
                let state = stateArr[stateArr.length-1];
                
                //검색 설정 
                if(state.searchPaperTitle != ""){
                    isSearch = true;
                    this.isSearchArea = true;
                    this.searchPaperTitle = state.searchPaperTitle;
                }
                //페이지 설정 
                if(pageParam != state.page){
                    obj.page = state.page;
                    return;
                }
                // 테이블 정렬 설정 
                
                obj.sortBy[0] = state.sortKey;
                obj.sortDesc[0] = state.sortDesc; 

                // 미확인보드보기, 즐겨찾기 보기 체크박스 설정
                obj.isBookmarkFilter = state.isBookmarkFilter;
                obj.isReadFilter = state.isReadFilter;

                //필터 유지.
                obj.gradeCodeList = state.gradeCodeList;
                obj.statusList = state.statusList;
                obj.initFilter = {
                    gradeCodeList : state.gradeCheckYn == true ? obj.gradeCodeList : [],
                    statusList : state.statusCheckYn == true ? obj.statusList : []
                }          
            }else{
                if(isSearch == true) {
                    if(obj.searchPaperTitle == '') {
                        //프로그레스바 종료
                        this.hideLoadingbar();
                        obj.toastInfo.message = obj.$i18nUtil.trans("TB091");
                        obj.showToast(obj.toastInfo);
                        return;
                    }
                    pageParam = 1;
                }
            }

            if(obj.searchPaperTitle != null && obj.searchPaperTitle != undefined && obj.searchPaperTitle.length > 0) {
                obj.showSearchPaperTitle = true;
            } else {
                obj.showSearchPaperTitle = false;
            }

            obj.rtnSearchPaperTitle= obj.searchPaperTitle;

            let param = {
                url: '/api/copaper/paper/getProjectPaperList',
                method: 'post',
                req: {
                    projectId : this.projectInfo.project.projectId,
                    searchPaperTitle: "%" + obj.searchPaperTitle + "%",
                    limitRow: obj.itemsPerPage,
                    page: pageParam - 1,
                    sortKey: obj.sortBy[0],
                    sortDesc: obj.sortDesc[0],
                    isPaperBookmarkChecked: obj.isBookmarkFilter,
                    isPaperReadChecked: obj.isReadFilter,
                    gradeCodeList: obj.gradeCodeList,
                    statusCodeList: obj.statusList,
                }
            };
            obj.COWORK_REST_ACTION(param)
            .then((res) => {
                //프로그레스바 종료
                this.hideLoadingbar();
                if(res.errorCode == null) {
                    obj.boardList = res.result.paperList.content;
                    obj.boardListFilter = res.result.paperList.content;
                    obj.totalElements = res.result.paperList.totalElements;
                    obj.pageCount = res.result.paperList.totalPages;
                    
                    obj.backDataSet = true;
                    
                    // 해더 부분 보드추가 버튼 활성화.
                    this.$emit("folderLength",1,null);

                    // this.initFilter = {
                    //     gradeCodeList : this.gradeCheckYn == true ? this.gradeCodeList : [],
                    //     categoryMidCodeList : this.categoryCheckYn == true ? this.categoryMidCodeList : []
                    // }

                    // sessionStorage에 저장. 
                    let sessionState = JSON.parse(window.sessionStorage.getItem("dashboard")) || [];
                    if(sessionState.length != 0){
                        let lastState = sessionState.pop();
                        // lastState.categoryMid = selectedFolderInfo.categoryMid;
                        // lastState.projectId = selectedFolderInfo.projectId;
                        lastState.searchPaperTitle = obj.searchPaperTitle;
                        lastState.page = pageParam;
                        lastState.isBookmarkFilter = obj.isBookmarkFilter;
                        lastState.isReadFilter = obj.isReadFilter;
                        lastState.sortDesc = obj.sortDesc[0];
                        lastState.sortKey = obj.sortBy[0];
                        lastState.limitRow = obj.itemsPerPage;
                        // lastState.selectedFolderIndex = obj.selectedFolderIndex;
                        lastState.gradeCodeList = obj.gradeCodeList;
                        lastState.statusList = obj.statusList;
                        lastState.gradeCheckYn = obj.gradeCheckYn;
                        lastState.statusCheckYn = obj.statusCheckYn;
                        sessionState.push(lastState);
                        window.sessionStorage.setItem("dashboard", JSON.stringify(sessionState));
                    }
                }
            })
            .catch(function (err) {
                console.log(err);
            });
        },
        fireFilterRead(){
            let obj = this;
            if(obj.page == 1) {
                obj.changeTableData = true;
            } else {
                obj.page = 1;
            }
        },
        fireFilterBookmark(){
            let obj = this;
            if(obj.page == 1) {
                obj.changeTableData = true;
            } else {
                obj.page = 1;
            }
        },
        getSearchBoardList(){
            this.isSearch = true;
            let obj = this;
            if(obj.page == 1) {
                obj.changeTableData = true;
            } else {
                obj.page = 1;
            }
        },
        clearSearchPaperTitle(){
            let obj = this;
            obj.searchPaperTitle = '';
            obj.rtnSearchPaperTitle = '';
            obj.showSearchBoardTitle = false;
            obj.isSearch = false;
            if(obj.page == 1) {
                obj.changeTableData = true;
            } else {
                obj.page = 1;
            }
        },
        /* 즐겨찾기 설정/해제 */
        toggleBookmark(board) {
            let obj = this;
            let reqData = {};
            reqData.params ={
                paperId: board.paperId,
                bookmarkId:board.paperBookmarkId
            }
            reqData.req = obj.req;
            reqData.url = "/api/copaper/bookmark/savePaperBookmark";
            reqData.method = "post";
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(res => {
                board.paperBookmarkId = res.result;
                if(board.paperBookmarkId != null) {
                obj.toastInfo.message = obj.$i18nUtil.trans('TB041');
                obj.showToast(obj.toastInfo);
                } 
                else {
                obj.toastInfo.message = obj.$i18nUtil.trans('TB042');
                obj.showToast(obj.toastInfo);
                }
                obj.changeTableData = true;
            }) 
            .catch(function(err) {
                console.log(err);
            });
        },
        updateCommonFilterE(filterData) {
            let obj = this;
            obj.gradeCodeList = filterData.filterGradeList;
            obj.statusList = filterData.filterStatusList;
            obj.gradeCheckYn = filterData.gradeCheckYn;
            obj.statusCheckYn = filterData.statusCheckYn;
            if(obj.page == 1) {
                obj.changeTableData = true;
            } else {
                obj.page = 1;
            }
        },
        getEvaluateClassAndText(board) {
            let rtnEvaluateJson = {evaluateClass: '', evaluateText: ''};
            // exceeded
            if(board.paperStatus == 'GOOD') {
                rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-good";
                rtnEvaluateJson.evaluateText = this.$i18nUtil.trans("entity.paper.paperStatus.GOOD","정상");
            }
            // on track
            else if(board.paperStatus == 'SO') {
                rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-so";
                rtnEvaluateJson.evaluateText = this.$i18nUtil.trans("entity.paper.paperStatus.SO","이슈 발생");
            }
            // at risk
            else if(board.paperStatus == 'DELAY') {
                rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-delay";
                rtnEvaluateJson.evaluateText = this.$i18nUtil.trans("entity.paper.paperStatus.DELAY","보고 필요");
            }
            // off track
            else if(board.paperStatus == 'EXCEEDED') {
                rtnEvaluateJson.evaluateClass = "ico-txt-evaluate-exceeded";
                rtnEvaluateJson.evaluateText = this.$i18nUtil.trans("entity.paper.paperStatus.EXCEEDED","종료");
            }
            return rtnEvaluateJson;
        },
        goBoard(board) {
            window.sessionStorage.setItem("moveBoard",true); 
            let postPath = board.paperProjectLinkId == null ? (board.paperId) :  (board.paperId+"/"+board.paperProjectLinkId); 
            let path = "/general/board/" + postPath;
            this.$router.push(path);
        },
        checkInOut(event, item, on, attrs){   
            let obj =this;
            
            // if( ( !this.loginUserIsInternalUser ||  this.userInfo == null ) && event.isTrusted){
            //   event.target.click();
            //   obj.toastInfo.message = obj.$i18nUtil.trans("TB044");
            //   obj.showToast(obj.toastInfo);
            // }
            if(item != null && item != undefined) {
            
            if(attrs["aria-expanded"] == "false") {
                let param = {
                url: '/api/copaper/paper/getPaperAuth',
                method: 'post',
                req: {
                    paperId: item.paperId,
                    checkRoleId: 'NOR_BRD_WRITE:false|NOR_BRD_COPY|NOR_BRD_DELETE|NOR_BRD_READ',
                    isCheckInternalUser: true,
                }
                };
                //프로그레스바 시작 
                
                // obj.showLoadingbar();
                obj.COWORK_REST_ACTION(param)
                .then(function (res) {
                //프로그레스바 종료
                // obj.hideLoadingbar();
                if(res.errorCode == null) {
                // 내부직원/외부직원
                let isInternalUserFlag = res.result.isInternalUser;
                let cfrcUse = res.result.isCfrcUse;
                let sharUse = res.result.isSharUse;
                
                // 0: 쓰기 권한
                // 1: 복제 권한
                // 2: 삭제 권한
                // 3: 읽기 권한
                let paperAuthList = res.result.paperAuthList;
                
                let moreItemList = event.target.parentElement.lastChild.firstChild.lastChild.children;
                if(moreItemList && moreItemList.length > 0) {
                    // 정보공유/회의협의 게시 권한없음 토스트 알림 뜨도록 설정
                    item.checkPostYn = true;

                    let newWindowText = obj.$i18nUtil.trans("button.paper.open.newWindow","새 창으로 보기");
                    let sharePostText = obj.$i18nUtil.trans("title.ReqPostModal.shareInfo","정보공유 게시");
                    let cfrcPostText = obj.$i18nUtil.trans("title.ReqPostModal.cooperation","회의/협의 게시");
                    let boardUrlCopyText = obj.$i18nUtil.trans("button.paper.copy.url","보드 URL 복사");
                    let copyBoardText = obj.$i18nUtil.trans("button.paper.copy","보드 복제");
                    let deleteBoardText = obj.$i18nUtil.trans("button.paper.delete","보드 삭제");
                    for (let mItem of moreItemList) {
                    // 임직원
                    if(isInternalUserFlag) {
                        // 전체공개 
                        if(obj.projectInfo.cogroup.publicYn == 1) {
                        // 새 창으로 보기
                        if(mItem.textContent == newWindowText && paperAuthList[3]["allow"]) {
                            if(mItem.classList.contains("hidden")) {
                            mItem.classList.remove("hidden");
                            }
                        }
                        // 정보공유 게시 (2021.03.30 정보공유, 회의/협의 분리)
                        else if(mItem.textContent == sharePostText && sharUse) {
                            if(mItem.classList.contains("hidden")) {
                            mItem.classList.remove("hidden");
                            }
                            // 보드 멤버인 경우만
                            if(paperAuthList[0]["allow"]) {
                            // 토스트 안뜨고 레이어 뜨도록 설정
                            item.checkPostYn = false;
                            }
                            // // 멤버
                            // else {
                            //   // 전체공개 > 전체공개보드의 경우
                            //   if(item.docGrade == "NORMAL") {
                            //     if(mItem.classList.contains("hidden")) {
                            //       mItem.classList.remove("hidden");
                            //     }
                            //   }
                            // }
                        } 
                        // 회의/협의 게시
                        else if(mItem.textContent == cfrcPostText && cfrcUse) {
                            if(mItem.classList.contains("hidden")) {
                            mItem.classList.remove("hidden");
                            }
                            // 보드 멤버인 경우만
                            if(paperAuthList[0]["allow"]) {
                            // 토스트 안뜨고 레이어 뜨도록 설정
                            item.checkPostYn = false;
                            }
                        }
                        // 보드 URL 복사
                        else if(mItem.textContent == boardUrlCopyText) {
                            // 권한없음 토스트 뜨지 않도록 설정
                            item.checkUrlBoardFlag = false;
                            if(mItem.classList.contains("hidden")) {
                            mItem.classList.remove("hidden");
                            }
                            // 운영자/보드 생성자/멤버/보드멤버/전체공개 > 전체공개보드
                            if(!paperAuthList[0]["allow"]) {
                            // 권한없음 토스트 뜨도록 설정
                            item.checkUrlBoardFlag = true;
                            }
                        }
                        // 보드 복제 권한체크
                        else if(mItem.textContent == copyBoardText) {
                            if(!mItem.classList.contains("hidden")) {
                            mItem.classList.add("hidden");
                            }
                            if(paperAuthList[1]["allow"]) {
                            mItem.classList.remove("hidden");
                            }
                        }
                        // 보드 삭제 권한체크
                        else if(mItem.textContent == deleteBoardText) {
                            if(!mItem.classList.contains("hidden")) {
                            mItem.classList.add("hidden");
                            }
                            if(paperAuthList[2]["allow"] && item.regUserId == obj.projectInfo.loginUserId) {
                            mItem.classList.remove("hidden");
                            }
                        }
                        
                        }
                        // 멤버만 공개 
                        else {
                        // 새 창으로 보기
                        if(mItem.textContent == newWindowText && paperAuthList[3]["allow"]) {
                            if(mItem.classList.contains("hidden")) {
                            mItem.classList.remove("hidden");
                            }
                        }
                        // 정보공유 게시 (2021.03.30 정보공유, 회의/협의 분리)
                        else if(mItem.textContent == sharePostText && sharUse) {
                            if(mItem.classList.contains("hidden")) {
                            mItem.classList.remove("hidden");
                            }
                            // 보드 멤버인 경우만
                            if(paperAuthList[0]["allow"]) {
                            // 토스트 안뜨고 레이어 뜨도록 설정
                            item.checkPostYn = false;
                            }
                            // // 멤버
                            // else {
                            //   // 전체공개 > 전체공개보드의 경우
                            //   if(item.docGrade == "NORMAL") {
                            //     if(mItem.classList.contains("hidden")) {
                            //       mItem.classList.remove("hidden");
                            //     }
                            //   }
                            // }
                        }
                        // 회의/협의 게시
                        else if(mItem.textContent == cfrcPostText && cfrcUse) {
                            if(mItem.classList.contains("hidden")) {
                            mItem.classList.remove("hidden");
                            }
                            // 보드 멤버인 경우만
                            if(paperAuthList[0]["allow"]) {
                            // 토스트 안뜨고 레이어 뜨도록 설정
                            item.checkPostYn = false;
                            }
                        }
                        // 보드 URL 복사
                        else if(mItem.textContent == boardUrlCopyText) {
                            // 권한없음 토스트 뜨지 않도록 설정
                            item.checkUrlBoardFlag = false;
                            if(mItem.classList.contains("hidden")) {
                            mItem.classList.remove("hidden");
                            }
                            // 운영자/보드 생성자/멤버/보드멤버/전체공개 > 전체공개보드
                            if(!paperAuthList[3]["allow"]) {
                            // 권한없음 토스트 뜨도록 설정
                            item.checkUrlBoardFlag = true;
                            }
                        }
                        // 보드 복제 권한체크
                        else if(mItem.textContent == copyBoardText) {
                            if(!mItem.classList.contains("hidden")) {
                            mItem.classList.add("hidden");
                            }
                            if(paperAuthList[1]["allow"]) {
                            mItem.classList.remove("hidden");
                            }
                        }
                        // 보드 삭제 권한체크
                        else if(mItem.textContent == deleteBoardText) {
                            if(!mItem.classList.contains("hidden")) {
                            mItem.classList.add("hidden");
                            }
                            if(paperAuthList[2]["allow"] && item.regUserId == obj.projectInfo.loginUserId) {
                            mItem.classList.remove("hidden");
                            }
                        }
                        }
                        
                    }
                    // 외부직원
                    else {
                        // 전체공개
                        if(obj.projectInfo.cogroup.publicYn == 1) {
                        // 보드 URL 복사
                        if(mItem.textContent == newWindowText) {
                            if(mItem.classList.contains("hidden")) {
                            mItem.classList.remove("hidden");
                            }
                        }
                        // 보드 URL 복사
                        else if(mItem.textContent == boardUrlCopyText) {
                            // 권한없음 토스트 뜨지 않도록 설정
                            item.checkUrlBoardFlag = false;
                            if(mItem.classList.contains("hidden")) {
                            mItem.classList.remove("hidden");
                            }
                            // 외부 직원 : 읽기 권한 없을 경우
                            if(!paperAuthList[3]["allow"]) {
                            // 권한없음 토스트 뜨도록 설정
                            item.checkUrlBoardFlag = true;
                            }
                        } 
                        else {
                            if(!mItem.classList.contains("hidden")) {
                            mItem.classList.add("hidden");
                            }
                        }
                        }
                        // 멤버만 공개
                        else {
                        if(!mItem.classList.contains("hidden")) {
                            mItem.classList.add("hidden");
                        }
                        }
                    }
                    }
                }
                }
                })
                .catch(function (err) {
                console.log(err);
                });
            }
            }
        },
        /* 정보공유 게시 */
        infoShareReqPost(board){
            if(board.checkPostYn == true) {
                this.toastInfo.message = this.$i18nUtil.trans("AB082");
                this.showToast(this.toastInfo);
                return;
            }
            const modalInfo = {
                title: this.$i18nUtil.trans("title.ReqPostModal.shareInfo","정보공유 게시"),
                name: "infoShareModal",
                method: "post",
                width: "800px",
                // height: "303px",
                obj: this.$modal,
                paperId: board.paperId,
                component: reqPost,
            };
            this.showModal(modalInfo);
        },
        /* 회의/협의 게시 */
        cooperationReqPost(board){
            if(board.checkPostYn == true) {
                this.toastInfo.message = this.$i18nUtil.trans("AB082");
                this.showToast(this.toastInfo);
                return;
            }
            const modalInfo = {
                title: this.$i18nUtil.trans("title.ReqPostModal.cooperation","회의/협의 게시"),
                name: "cooperationModal",
                method: "post",
                width: "800px",
                // height: "408px",
                obj: this.$modal,
                paperId: board.paperId,
                addfolderName:board.paperTitle,
                component: reqPost,
            };
            this.showModal(modalInfo);
        },
        /* 보드url 복사 */
        copyURL(text,board){
            if(board.checkUrlBoardFlag == true) {
                this.toastInfo.message = this.$i18nUtil.trans("AB082");
                this.showToast(this.toastInfo);
                return;
            }
            let element = document.createElement("input");
            let s = element.style;
            s.border = "0";
            s.width = "1px";
            s.height = "1px";
            s.background = "#fff";
            s.color = "#fff";
            element.value = text+board.paperId;
            this.$el.appendChild(element);
            element.select();
            document.execCommand("copy");
            $(element).remove();
            this.toastInfo.message = this.$i18nUtil.trans('TB010');
            this.showToast(this.toastInfo);
        },
        /* 현재 url */
        currentURL() {
            let url = window.location.href;
            let match = /^(.+)\/(dashboard)\/(PROJ[a-zA-Z0-9]+)/.exec(url);
            if (match.length > 3) {
                url = match[1] + "/board/";
            }
            return url;
        },
        /* 업무보드 복제 */
        copyPaperModal(board) {
            const modalInfo = {
                title: this.$i18nUtil.trans("title.CopyBoardModal.001","업무보드 복제"),
                name: "copyBoardModal",
                method: "post",
                width: "800px",
                // height: "516px",
                obj: this.$modal,
                paperId: board.paperId,
                groupId: board.groupId,
                component: CopyBoardModal,
            };
            this.showModal(modalInfo);
            
        },
        /* 보드삭제 */
        deleteBoard(board){
            let obj = this;
            obj.showConfirmDialogWithJSON({
                confirmMessage: obj.$i18nUtil.trans('AB001'),
                confirmBtnText: obj.$i18nUtil.trans("button.dialog.delete","삭제"),
                confirmBtnCallback: obj.deletePaperApiCall,
                modalParam: {board: board},
                cancelBtnText : obj.$i18nUtil.trans("button.cancel","취소"),
            });
        },
        deletePaperApiCall(callbackData) {
            let obj = this;
            let reqData = {};
            reqData.params ={
                paperId : callbackData.modalParam.board.paperId,
                groupId : callbackData.modalParam.board.groupId,
                categoryMid : callbackData.modalParam.board.categoryMid,
                deleteYn :"1"
            }
            reqData.req = obj.req;
            reqData.url = "/api/copaper/paper/deletePaper";
            reqData.method = "post";
            obj.showLoadingbar();
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(res => {
                obj.hideLoadingbar();
                if(res.fncAuthRst != null) {
                    // 삭제 권한이 없을 경우
                    if(!res.fncAuthRst.allow) {
                        obj.toastInfo.message = obj.$i18nUtil.trans('TB056');
                        obj.showToast(obj.toastInfo);
                        return;
                    }
                }
                obj.toastInfo.message = obj.$i18nUtil.trans('TB027');
                obj.showToast(obj.toastInfo);
                const idx = obj.boardList.findIndex(function(data) {
                    return data.paperId == callbackData.modalParam.board.paperId;
                });
                obj.boardList.splice(idx,1);
                const index = obj.boardListFilter.findIndex(function(data) {
                    return data.paperId == callbackData.modalParam.board.paperId;
                });
                // obj.setBoardFilter();
            })
            .catch(function(err) {
                console.log(err);
            });
        },
        checkHours(lastUpdated) {
            let now = this.$moment()
            let before24hours = this.$moment().subtract(1,'days')
            let lastUpdatedTime = this.$moment(lastUpdated)
            
            if(lastUpdatedTime.isBetween(before24hours, now)) {
                // 24시간 이내
                return true;
            }else{
                // 24시간 이후
                return false;
            }
        },
        replaceAll(str, input, output) {
            return str.split(input).join(output);
        },
        addBoard(item) {
            let obj = this;
            let reqData = {};
            reqData.params ={
            }
            reqData.req = obj.req;
            reqData.url = "/api/copaper/paper/getGeneratedPaperId";
            reqData.method = "post";
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(res => {
                let errorCode = res.errorCode;
                let addPaperId = res.result;
                const modalInfo = {
                title: obj.$i18nUtil.trans("title.RegistBoardModal.000","업무보드 추가"),
                name: "registBoard",
                method: "post",
                width: "800px",
                // height: "493px",
                obj: obj.$modal,
                paperId: addPaperId, 
                categoryMid: null,
                groupId:  this.projectInfo.cogroup.groupId, 
                projectId: this.projectInfo.project.projectId || obj.$route.item.category.projectId,
                projectName: this.projectInfo.project.projectName,
                paperTitle: "",
                contentPath: "",
                docGrade: String(this.publicYn) == "1" ? "NORMAL" : "RESTRICT",
                component: RegistBoardModal,
                //localselectIidx: obj.localselectIidx,
                parentCategoryMid: null
                };
                obj.showModal(modalInfo);
            })
            .catch(function(err) {
                console.log(err);
            });
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/project/detail/tab/allList/DashboardAllList.vue